import { useQuery as useReactQuery } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import type { Hash } from 'viem'
import type { QuarantinedTransactions, TransactionList } from 'generated/reactQueryClient'
import { publicClientL2 } from 'lib/viem'

export const useZircuitRPCGetTransactions = (
  {
    variables: { cursor, data },
  }: {
    variables: { cursor: string; data: QuarantinedTransactions | TransactionList | undefined }
  },
  options?: Omit<
    Parameters<
      typeof useReactQuery<Awaited<ReturnType<typeof publicClientL2.getTransaction>>[]>
    >[0],
    'enabled' | 'queryKey' | 'queryFn'
  >
) => {
  const { pathname } = useRouter()

  return useReactQuery({
    enabled: Boolean(data?.length),
    queryKey: ['useZircuitRPCGetTransactions', pathname, cursor],
    queryFn: async () => {
      if (!data?.length) {
        return []
      }

      const results = await Promise.allSettled(
        data.map((tx) => {
          const hash = 'txHash' in tx ? tx.txHash : tx.l2TxHash
          return publicClientL2.getTransaction({ hash: hash as Hash })
        })
      )

      return results.filter((result) => result.status === 'fulfilled').map((result) => result.value)
    },
    ...options,
  })
}
